// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_unit_code: yup.string().label("Code").required(),
  mr_unit_name: yup.string().label("Unit Name").required()
})